// extracted by mini-css-extract-plugin
export var actionButton = "_x9-2";
export var card = "_x9-0";
export var disambiguationList = "_x9-3";
export var errorCard = "_x9-4";
export var row = "_x9-1";